import styled from 'styled-components';

export const OrderInfoContent = styled.div`
	overflow-y: auto;
	height: 100%;
	padding: 12px 10px;
`;

export const MarginLeft = styled.div`
	margin-left: 11px;
`;

export const Content = styled.div`
	margin-bottom: 10px;
`;

export const TablesList = styled.div`
	display: flex;
	gap: 6px;
	flex-basis: 70px;
	flex-wrap: wrap;
`;

type MarginBottomProps = {
  $value?: string | number;
}
export const MarginBottom = styled.div<MarginBottomProps>`
	margin-bottom: ${props => {
    if (!props.$value) {
      return '12px';
    }

    if (typeof props.$value === 'number') {
      return `${props.$value}px`
    }

    return props.$value;
  }};
`;
